import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'

export interface ThemeState {
    bgColor: string
    nowPlayingBgColor: string
    playColor: string
    seekbarColor: string
    seekbarBgColor: string
    textColor: string
    articleBorderColor: string
    scrollbarColor: string
    scrollbarBgColor: string

    headerTextColor: string
    playerDateAndLengthColor: string
    articleTextColor: string
    articleTimestampColor: string
    pageHeadingColor: string
    articleDateAndLengthColor: string
    headerBackgroundColor: string
    popupBackgroundColor: string
    popupForegroundColor: string
    popupActiveForegroundColor: string
    footerBackgroundColor: string
    footerTextColor: string
    playerIconsColor: string
    playerDividerColor: string
}

const initialState: ThemeState = {
    bgColor: '#FFFFFF',
    nowPlayingBgColor: '#F2F2F2',
    playColor: '#039BE5',
    seekbarColor: '#039BE5',
    seekbarBgColor: '#D5D7D8',
    textColor: '#000000',
    articleBorderColor: '#D5D7D8',
    scrollbarColor: '#555',
    scrollbarBgColor: '#FFFFFF',

    headerTextColor: '#9A9A9A',
    playerDateAndLengthColor: '#9A9A9A',
    articleTextColor: '#000000',
    articleTimestampColor: '#9A9A9A',
    pageHeadingColor: '#039BE5',
    articleDateAndLengthColor: '#9A9A9A',
    headerBackgroundColor: '#FFFFFF',
    popupBackgroundColor: '#021524',
    popupForegroundColor: '#FFFFFF',
    popupActiveForegroundColor: '#FF0000',
    footerBackgroundColor: '#F2F2F2',
    footerTextColor: '#9A9A9A',

    playerIconsColor: '#9A9A9A',

    playerDividerColor: '#dbdbdb',
}

export const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: state => {
            const action = { payload: new URLSearchParams(window.location.search) }

            state.bgColor = action.payload.get('bgColor') ? '#' + action.payload.get('bgColor') : state.bgColor
            state.nowPlayingBgColor = action.payload.get('nowPlayingBgColor')
                ? '#' + action.payload.get('nowPlayingBgColor')
                : state.nowPlayingBgColor
            state.playColor = action.payload.get('playColor') ? '#' + action.payload.get('playColor') : state.playColor
            state.seekbarColor = action.payload.get('seekbarColor')
                ? '#' + action.payload.get('seekbarColor')
                : state.seekbarColor
            state.seekbarBgColor = action.payload.get('seekbarBgColor')
                ? '#' + action.payload.get('seekbarBgColor')
                : state.seekbarBgColor
            state.textColor = action.payload.get('textColor') ? '#' + action.payload.get('textColor') : state.textColor
            state.articleBorderColor = action.payload.get('articleBorderColor')
                ? '#' + action.payload.get('articleBorderColor')
                : state.articleBorderColor
            state.scrollbarColor = action.payload.get('scrollbarColor')
                ? '#' + action.payload.get('scrollbarColor')
                : state.scrollbarColor
            state.scrollbarBgColor = action.payload.get('scrollbarBgColor')
                ? '#' + action.payload.get('scrollbarBgColor')
                : state.scrollbarBgColor

            state.headerTextColor = action.payload.get('headerTextColor')
                ? '#' + action.payload.get('headerTextColor')
                : state.headerTextColor
            state.playerDateAndLengthColor = action.payload.get('playerDateAndLengthColor')
                ? '#' + action.payload.get('playerDateAndLengthColor')
                : state.playerDateAndLengthColor
            state.articleTextColor = action.payload.get('articleTextColor')
                ? '#' + action.payload.get('articleTextColor')
                : state.articleTextColor
            state.articleTimestampColor = action.payload.get('articleTimestampColor')
                ? '#' + action.payload.get('articleTimestampColor')
                : state.articleTimestampColor
            state.pageHeadingColor = action.payload.get('pageHeadingColor')
                ? '#' + action.payload.get('pageHeadingColor')
                : state.pageHeadingColor
            state.articleDateAndLengthColor = action.payload.get('articleDateAndLengthColor')
                ? '#' + action.payload.get('articleDateAndLengthColor')
                : state.articleDateAndLengthColor
            state.headerBackgroundColor = action.payload.get('headerBackgroundColor')
                ? '#' + action.payload.get('headerBackgroundColor')
                : state.headerBackgroundColor
            state.popupBackgroundColor = action.payload.get('popupBackgroundColor')
                ? '#' + action.payload.get('popupBackgroundColor')
                : state.popupBackgroundColor
            state.popupForegroundColor = action.payload.get('popupForegroundColor')
                ? '#' + action.payload.get('popupForegroundColor')
                : state.popupForegroundColor
            state.popupActiveForegroundColor = action.payload.get('popupActiveForegroundColor')
                ? '#' + action.payload.get('popupActiveForegroundColor')
                : state.popupActiveForegroundColor

            state.footerBackgroundColor = action.payload.get('footerBackgroundColor')
                ? '#' + action.payload.get('footerBackgroundColor')
                : state.footerBackgroundColor
            state.footerTextColor = action.payload.get('footerTextColor')
                ? '#' + action.payload.get('footerTextColor')
                : state.footerTextColor

            state.playerIconsColor = action.payload.get('playerIconsColor')
                ? '#' + action.payload.get('playerIconsColor')
                : state.playerIconsColor

            state.playerDividerColor = action.payload.get('playerDividerColor')
                ? '#' + action.payload.get('playerDividerColor')
                : state.playerDividerColor
        },
    },
})

export const { setTheme } = themeSlice.actions

export const selectTheme = (state: RootState) => state.theme

export default themeSlice.reducer
